import { grey } from '@mui/material/colors';

// Input grounds are the one override that cannot be a fixed value: a pale grey fill that separates
// a field from the page in light mode becomes a bright panel in dark mode.
export default (mode = 'light') => ({
  MuiUseMediaQuery: {
    defaultProps: {
      noSsr: true,
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : grey[50],
        borderRadius: 10,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        textTransform: 'none',
      },
      sizeMedium: {
        height: '40px',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      rounded: {
        borderRadius: 12,
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
      },
    },
  },
  MuiFormControl: {
    defaultProps: {
      size: 'small',
    },
  },
  MuiSnackbar: {
    defaultProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
      },
    },
  },
});
